module.exports = __webpack_public_path__ + "static/img/pinned-icon.ff36aee4.svg";